module.exports = __webpack_public_path__ + "img/4_2023_07_19.0a93d2d9.jpg";